import PropTypes from 'prop-types';

export function States({ bindValues }) {
  const geoStates = ['', 'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
    'AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'ON', 'PE', 'QC', 'SK'];

  return (
    <select className="form-select" name="Honoree State" {...bindValues}>
      {geoStates.map((eaState, index) => (
        <option key={index} value={eaState}>{eaState}</option>
      ))}
    </select>
  )
}

States.propTypes = {
  bindValues: PropTypes.object
}